export default __webpack_public_path__ + "static/la-salle-6b20ec2f7d8c8faf2a9e2824e6927e86.svg";